import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import { useParams } from "react-router-dom";


function Form() {

    const { id } = useParams();

    const endpointBackend = config.endpoints.backend;
    const path = '/governanceroom/clients/';
    const paths = {
        endpointSave: endpointBackend+'governanceroom/clients/save',
        endpointGetById: endpointBackend+'governanceroom/clients/getById',
        endpointQrcode: config.endpoints.backend+'core/applicationsinstances/qrcode',
        urlGoBack: path+'list',
        pathView: path+'view'
    }

    const labels = {
        labelTitleAdd:  "Novo Cliente",
        labelTitleEdit: "Editar Cliente",
        labelTitleView: 'Visualizar Cliente'
    }
    
    const form = {
        validateOnChange: true,
        fields: [
            {
                name: 'application_id',
                type: 'select',
                label: 'Aplicação',
                options: [],
                optionsEndpoint:{
                    endpoint: endpointBackend+'core/applications/getall',
                    label: 'application_name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'instance_name',
                type: 'text',
                label: 'Cliente',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'photo',
                type: 'fileS3',
                label: 'Foto/Logo (Sugestão: 100x100)',
                uploadPath: '/instance/photos/',
                extensionAccept: '.jpeg,.jpg,.png',
                limitFileSize: 5,
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'cnpj',
                type: 'CNPJ',
                label: 'CNPJ',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'company_name',
                type: 'text',
                label: 'Razão Social',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'fantasy_name',
                type: 'text',
                label: 'Nome Fantasia',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'municipal_registration',
                type: 'integer',
                label: 'Inscrição Municipal',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'state_registration',
                type: 'integer',
                label: 'Inscrição Estadual',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'portal_link',
                type: 'text',
                label: 'Link',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'address',
                type: 'address',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'phone',
                type: 'phone',
                label: 'Telefone',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'institutional_email',
                type: 'email',
                label: 'Email Institucional',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                options: [
                  { label: 'Ativo', value: '1' },
                  { label: 'Bloqueado', value: '0' },
                ],
                validations: {
                  required: true
                },
                columnSize: 12
            }           
        ],
        ...paths,
        ...labels
    }
    
    return (
        <div>
            <CustomFormContainer 
                form = {form} 
                content    = {<CustomForm form={form} />}
            />
        </div>
    );
}
export default Form;
